import React from 'react';
import styled from 'styled-components';
import { useFieldValidation } from '../../hooks/validation-field';
import { FieldContainer, Field, Label, HelperLine, HelperText, ErrorMessage } from '../field';
import { makeCustomField, makeCheckboxComponent, makeOptionLabel, makeInput, makeCheckmark } from './mixins';
const CustomField = styled(Field) `
  ${() => makeCustomField()}
`;
const CheckboxComponent = styled.div `
  ${props => makeCheckboxComponent(props)}
`;
const Input = styled.input `
  ${props => makeInput(props)}
`;
const OptionLabel = styled.label `
  ${props => makeOptionLabel(props)}
`;
const Checkmark = styled.span `
  ${props => makeCheckmark(props)}
`;
export const Checkbox = ({ name, id, readonly, label, onChange, onFocus, onBlur, disabled, validation: rules, errors, fieldOptions, checked, }) => {
    const { fieldStates, classes, setValue, setActive } = useFieldValidation(rules, errors, name, disabled);
    const handleOnChange = (event, callback) => {
        const { target } = event.target.value;
        setValue(target);
        callback && callback(event);
    };
    const handleOnBlur = (event, callback) => {
        setActive(false);
        callback && callback(event);
    };
    const handleOnFocus = (event, callback) => {
        setActive(true);
        callback && callback(event);
    };
    return (React.createElement(FieldContainer, null,
        fieldOptions && fieldOptions.label && React.createElement(Label, { htmlFor: id || `checkbox-${name}` }, fieldOptions.label),
        React.createElement(CustomField, Object.assign({}, fieldOptions, { states: Object.assign({}, fieldStates), className: classes }),
            React.createElement(CheckboxComponent, { fieldOptions: fieldOptions && { size: fieldOptions.size } },
                React.createElement(Input, { id: id || `radiobutton-${name}`, name: name, type: "checkbox", disabled: disabled, ref: rules, onChange: event => handleOnChange(event, onChange), onFocus: event => handleOnFocus(event, onFocus), onBlur: event => handleOnBlur(event, onBlur), defaultChecked: fieldOptions && fieldOptions.defaultChecked, fieldOptions: fieldOptions && { size: fieldOptions.size }, checked: checked }),
                React.createElement(OptionLabel, { fieldOptions: fieldOptions && { size: fieldOptions.size }, disabled: disabled, htmlFor: id, label: label }, label && label),
                React.createElement(Checkmark, { fieldOptions: fieldOptions && { size: fieldOptions.size } }))),
        ((fieldOptions && fieldOptions.helperText) || errors) && (React.createElement(HelperLine, null,
            errors && errors[name] && React.createElement(ErrorMessage, null, errors[name].message),
            fieldOptions && fieldOptions.helperText && errors && !errors[name] && (React.createElement(HelperText, null, fieldOptions.helperText))))));
};
export default Checkbox;
